import React, {useRef} from 'react';
import {IonButton, IonIcon, useIonAlert} from "@ionic/react";

interface ConfirmationButtonProps {
  shape?: 'round';
  size?: "default" | "large" | "small";
  color?: string;
  fill?: 'clear' | 'outline' | 'solid';
  disabled?: boolean;
  onConfirm: () => void;
  icon?: any;
  className?: string;
  children: any;
  title?: string;
  message?: string;
}

const ConfirmationButton: React.FC<ConfirmationButtonProps> = (props) => {
  const {shape, size, color, fill, disabled, onConfirm, icon, className, children} = props;
  const title = props.title || 'Confirmação';
  const message = props.message || 'Você tem certeza que deseja realizar esta ação?';
  const [presentAlert] = useIonAlert();
  const hasConfirmedRef = useRef(false);

  const onCancel = () => {

  }

  const onClick = () => {
    hasConfirmedRef.current = false;
    presentAlert({
      header: title,
      message: message,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: onCancel,
        },
        {
          text: 'Sim',
          role: 'confirm',
          handler: () => {
            if (hasConfirmedRef.current) return;
            hasConfirmedRef.current = true;
            onConfirm();
          },
        },
      ]
    });
  }

  return (
    <>
      <IonButton
        shape={shape}
        size={size}
        className={className}
        color={color}
        fill={fill}
        disabled={disabled}
        onClick={onClick}
      >
        {icon &&
          <IonIcon src={icon} slot="start"/>
        }
        {children}
      </IonButton>
    </>
  );
}

export default ConfirmationButton;
